import {useQuery} from '@tanstack/react-query';

import {getQualityAgentToken} from './auth';

export const AuthQueryKeys = {
  qualityAgentAccess: ['auth', 'quality-agent-access'] as const,
};

// Whether the current user is on the Quality Agent allowlist (maintained in the
// API's dynamic_config; the token endpoint 403s for everyone else). Probes by
// minting a token that is then discarded — the embedded app fetches its own
// during the iframe handshake. Access only changes when ops edits the list, so
// one probe per session is enough (staleTime: Infinity).
export function useQualityAgentAccessQuery(enabled: boolean) {
  return useQuery({
    queryKey: AuthQueryKeys.qualityAgentAccess,
    queryFn: async () => {
      await getQualityAgentToken();
      return true;
    },
    enabled,
    retry: false,
    staleTime: Infinity,
  });
}
